    import React, { Component } from 'react';
    import './Footer.css';
    import asterlabslogo from '../../images/asterlabslogo@4x.png';

    class Footer extends Component {

        render() {
            return (
            <div id="footer-wrapper">
                <div>
                    <img id="asterlabs-logo" src={asterlabslogo} alt="ASTER Labs"/>
                    <span>Activlink ver a1.1.1 ©2019</span>
                </div>
            </div> 
            );
        }
    }

    export default Footer;
